import React, { ReactElement, useMemo } from 'react';
import classNames from 'classnames';
import { Typography, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

import StepSection from '../StepSection/StepSection';

const useStyles = makeStyles<AlyceTheme>(({ spacing }) => ({
  textMargin: {
    marginBottom: spacing(2),
  },
  link: {
    display: 'inline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

interface IUnsubscribeFromCompanyProps {
  company: string;
  unsubscribeLink: string;
  onLinkClick: () => void;
}

const UnsubscribeFromCompany = ({
  company,
  unsubscribeLink,
  onLinkClick,
}: IUnsubscribeFromCompanyProps): ReactElement => {
  const classes = useStyles();
  const title = useMemo(() => `Step 2. Unsubscribe from ${company} (optional)`, [company]);

  return (
    <StepSection title={title} iconProps={{ icon: 'sign-out-alt', color: 'primary' }}>
      <Typography
        data-testid="companyUnsubscribeText"
        className={classNames('Body-Regular-Left-Static', classes.textMargin)}
      >
        The above selections will only affect gift invitations you have already received or may receive via Alyce. You
        will still be on the prospect list from {company}.
      </Typography>
      <Typography className="Body-Regular-Left-Static-Bold">
        <Link
          data-testid="companyUnsubscribeLink"
          className={classes.link}
          href={unsubscribeLink}
          onClick={onLinkClick}
          target="_blank"
          underline="hover"
        >
          Please click here to go to {company}’s unsubscribe page.
        </Link>
      </Typography>
    </StepSection>
  );
};

export default UnsubscribeFromCompany;
